module.exports = __webpack_public_path__ + "static/media/welcome-img2.331b3567.jpg";